import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  Output,
  SimpleChanges,
  ViewChild,
} from "@angular/core";
import { FormGroup } from "@angular/forms";
import { HardFormService } from "@hardcode-kz/ui";
import { IFormFieldFilter } from "@models/form/base-config";
import { NgbPopover, Placement } from "@ng-bootstrap/ng-bootstrap";
import { DictionaryFormService } from "@services/dictionary/dictionary-form.service";
import { Subscription } from "rxjs";

@Component({
  selector: "ui-filter",
  templateUrl: "./ui-filter.component.html",
  styleUrl: "./ui-filter.component.scss",
  standalone: false,
})
export class UIFilterComponent implements OnChanges, OnDestroy {
  @Input() fields: IFormFieldFilter<any>[] = [];
  @Input() filterCallback: (data: any) => {};
  @Input() showClearIconButton = false;
  @Input() showClearTextButton = false;
  @Input() resetFiltersOnClear: boolean = false;
  @Input() value: any;
  @Input() dicType?: string;
  @Input() templateColumns: string;
  @Input() customForm?: FormGroup;
  @Input() popoverCssClass?: string;

  @Output() searchEmit = new EventEmitter<any>();

  form?: FormGroup;
  outsideFields: IFormFieldFilter<any>[] = [];
  insideFields: IFormFieldFilter<any>[] = [];
  subscriptions: Subscription[] = [];
  open = false;
  count = 0;
  emitValue = true;

  readonly placement = [
    "bottom-right",
    "bottom-left",
    "auto",
  ] as Array<Placement>;

  @ViewChild("filterPopoverTrigger") filterPopoverTrigger: NgbPopover;

  constructor(
    private readonly formConstructor: HardFormService,
    private readonly dicFormService: DictionaryFormService,
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes["value"]) {
      this.form?.patchValue(this.value, {
        emitEvent: false,
      });
    }

    if (changes["fields"]) {
      this.clearSubscribes();

      if (this.customForm) {
        this.form = this.customForm;
      } else {
        this.form = this.formConstructor.buildReactiveForm(this.fields);
      }

      if (this.value) {
        this.form.patchValue(this.value);
      }
      this.outsideFields = this.fields.filter((c) => c?.outside);
      this.insideFields = this.fields.filter((c) => !c?.outside);
      this.subscriptions = [];

      this.outsideFields.forEach((field) => {
        const subscription = this.form
          ?.get(field.name)
          ?.valueChanges.subscribe(() => {
            if (this.emitValue) {
              this.setSearchEmit();
            }
          });

        this.subscriptions.push(subscription);
      });

      this.calcCount();
    }
  }

  setSearchEmit(clearAll?: boolean): void {
    const data = this.form.getRawValue();

    if (this.dicType) {
      this.dicFormService.setFilterValue(data, this.dicType);
    }

    this.searchEmit.emit(
      clearAll ? null : this.filterCallback ? this.filterCallback(data) : data,
    );
  }

  clear(): void {
    this.emitValue = false;
    this.count = 0;
    this.form.reset();
    this.resetFiltersOnClear ? this.setSearchEmit(true) : this.setSearchEmit();
    if (this.value) {
      setTimeout(() => {
        this.emitValue = false;
        this.form.patchValue(this.value);
        this.emitValue = true;
      }, 0);
    }
    this.close();
    this.emitValue = true;
  }

  calcCount(): void {
    this.count = 0;

    this.insideFields.forEach((field) => {
      if (field?.params?.direction && field?.name) {
        const config = field.params?.fields?.find((c) => !!c?.params?.dicType);

        if (config && this.form.get(field.name).value[config.name]) {
          this.count += 1;
        }
      } else {
        if (
          (this.form.get(field.name).value !== null &&
            this.form.get(field.name).value !== undefined &&
            this.form.get(field.name).value !== "" &&
            !field?.params?.multiple) ||
          (field?.params?.multiple &&
            this.form.get(field.name).value?.length > 0)
        ) {
          this.count += 1;
        }
      }
    });
  }

  search(): void {
    this.calcCount();
    this.setSearchEmit();
    this.close();
  }

  close(): void {
    if (this.filterPopoverTrigger) {
      this.filterPopoverTrigger.close(true);
    }

    this.open = false;
  }

  setOpen(): void {
    this.open = true;
  }

  clearSubscribes(): void {
    this.subscriptions.forEach((subscription) => {
      subscription.unsubscribe();
    });
  }

  ngOnDestroy() {
    this.clearSubscribes();
  }
}
